module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-theme-ui/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[],"extensions":[".mdx",".md"],"defaultLayouts":{"default":"/zeit/bb74bfb/node_modules/@undataforum/gatsby-theme-base/src/components/mdx-page.js"},"gatsbyRemarkPlugins":["gatsby-remark-smartypants"]},
    }]
